// src/tri-grade/tri-grade.js

import { VehicleManager } from '../vehicleManager.js';
let v; // VehicleManager instantiated on page load

const MAX_GRADIENT = 30.0;
const DEF_GRADIENT = 5.0;
let defaultVehicleGroup = 1;
let defaultLoadOption = 16.5;

let vehiclesLoaded = false;
let inputsHidden = true;

const customGroupValue = -1;
const customEntry = {
   id: 999,
   category: 'NA',
   description: 'Custom Vehicle',
   length: 'Unknown',
   mass: 'Unknown',
   gcm: -1,
   approved: '',
   network: '',
   image: 'tri-drive-custom.png',
   axle_groups: 2,
   axles: [
      { min: 1, max: 2 },
      { min: 1, max: 2 },
   ],
};

const roadTyreCombos = [
   { surface: 'Asphalt and Concrete (dry)', mu: 0.8 },
   { surface: 'Asphalt (wet) 0.5-0.7', mu: 0.6 },
   { surface: 'Concrete (wet)', mu: 0.8 },
   { surface: 'Gravel', mu: 0.6 },
   { surface: 'Earth road (dry)', mu: 0.68 },
   { surface: 'Earth road (wet)', mu: 0.55 },
];

$(function () {
   try {
      v = new VehicleManager('wa-trucks', true);
      $('.grad-input-col').hide();
      $('#reset').hide();
      loadPage();
      initControls();
   } catch (error) {
      console.error(error.message);
      //Redirect to an error page
      window.location.href =
         '/error?message=' + encodeURIComponent('An unexpected error occurred on starting the grade tool.');
   }
});

function loadPage() {
   // setup the vehicles group selector
   // Populate vehicle types dropdown
   const groups = v.getVehicleGroups();
   $('#vehicle-group').empty();
   for (let i = 0; i < groups.length; i++) {
      const name = groups[i].name;
      const val = groups[i].index;
      $('#vehicle-group').append(new Option(name, val));
   }

   const customEntries = [];
   customEntries.push(customEntry);
   v.initVehicles(customEntries, function () {
      vehiclesLoaded = true;
      resetFormValues();
   });

   $('.load-select').prop('disabled', true); //load selector now disabled
}

function resetFormValues() {
   $('#md-tandem').val(defaultLoadOption);
   $('#mdValue').val(defaultLoadOption);
   $('#frictionValue').val(roadTyreCombos[0].mu); // update the friction value (mu)

   if (vehiclesLoaded) {
      $('#vehicle-group').val(defaultVehicleGroup);
      selectVehicleGroup(defaultVehicleGroup);
   }

   // default mode and gradient
   setMode('useLoad');
   setGradient(DEF_GRADIENT);
}

function initControls() {
   // handle vehicle group changing
   $('#vehicle-group').on('change', function () {
      selectVehicleGroup(this.value);
   });

   // second selector - vehicle type
   $('#vehicle-type').on('change', function () {
      selectVehicleType(this.value);
   });

   //
   // Setup MD - axle load (t)
   //
   $('.load-select').on('change', function () {
      // there are are now two selectors, tri and tandem
      $('#mdValue').val(this.value);
      $('#mdValue').addClass('highlight-change');
      $('#info-load').addClass('highlight-text');
      // Remove the highlight after a delay
      setTimeout(function () {
         $('#mdValue').removeClass('highlight-change');
         $('#info-load').removeClass('highlight-text');
      }, 2000);
   });

   //
   // Setup tyre road combination dropdown
   //
   for (let i = 0; i < roadTyreCombos.length; i++) {
      $('#roadTyreCombo').append(new Option(roadTyreCombos[i].surface, i));
   }

   $('#roadTyreCombo').on('change', function () {
      $('#frictionValue').val(roadTyreCombos[this.value].mu); // update the friction value (mu)
      $('#frictionValue').addClass('highlight-change');
      $('#info-friction').addClass('highlight-text');
      // Remove the highlight after a delay
      setTimeout(function () {
         $('#frictionValue').removeClass('highlight-change');
         $('#info-friction').removeClass('highlight-text');
      }, 2000);
   });

   // customise button
   $('#customise').on('click', function () {
      // select the custom group and its default.
      v.setVehicleGroup(customGroupValue);

      inputsHidden = false;
      showHideInputs(inputsHidden);

      // Hide the customise button and show the reset button.
      $('#reset').show();
      $('#customise').hide();

      // disable the vehicle and load selector
      $('#vehicle-type').prop('disabled', true);
      $('#vehicle-group').prop('disabled', true);
      $('.load-select').prop('disabled', true);
   });

   // reset button
   $('#reset').on('click', function () {
      //
      inputsHidden = true;
      showHideInputs(inputsHidden);
      resetFormValues();
      // Hide the reset button and show the customise button.
      $('#reset').hide();
      $('#customise').show();
      $('#vehicle-type').prop('disabled', false);
      $('#vehicle-group').prop('disabled', false);
      //$('.load-select').prop('disabled', false);
   });

   // change mode radio button
   $('input[name="btnradio"]').on('change', function () {
      let mode = getMode();
      showMode(mode);
      // recalculate the result again when the mode changes so there is always a
      // result shown.
      const selectedVehicle = v.getActiveVehicle();
      calculate(selectedVehicle);
   });

   // When middle fields change - re-calculate
   $('.grad-input').on('change', function () {
      const selectedVehicle = v.getActiveVehicle();
      calculate(selectedVehicle);
   });
}

//
// Vehicles and types selects
//

function selectVehicleGroup(groupIndex) {
   // On Change vehicle group
   v.setVehicleGroup(groupIndex);
   let group = v.getActiveVehicleGroup();

   // update the load selector based on number of drive axles (tandem or tri) for the group
   $('.tri-drive-option').hide();
   $('.tandem-drive-option').hide();
   if (group.drive_axles == 2) {
      $('.tandem-drive-option').show();
      var tandemVal = $('#md-tandem').val();
      $('#mdValue').val(tandemVal); // make sure the md value is correct since selector changed
   } else {
      $('.tri-drive-option').show();
      var triVal = $('#md-tri').val();
      $('#mdValue').val(triVal);
   }

   // Populate vehicle types dropdown
   const names = v.getActiveGroupVehicleNames();
   $('#vehicle-type').empty();
   for (let i = 0; i < names.length; i++) {
      $('#vehicle-type').append(new Option(names[i], i));
   }
   selectVehicleType(0);
}

function selectVehicleType(vehicleIndex) {
   // Called when user changes vehicle group (sets to default vehicle) or type
   v.setActiveVehicle(vehicleIndex);
   const selectedVehicle = v.getActiveVehicle();
   updateDefaultMd();
   changeVehicle(selectedVehicle);
   calculate(selectedVehicle);
}

function updateDefaultMd() {
   // update the load selector based on number of drive axles (tandem or tri) for the group
   const groupAxles = v.getActiveVehicleGroup().drive_axles;
   const approved = v.getActiveVehicle().approved;

   let defVal = '16.5';
   if (groupAxles == 2) {
      if (approved === 'Level 1') defVal = '17.0';
      else if (approved === 'Level 2') defVal = '17.0';
      else if (approved === 'Level 3') defVal = '17.5';
      else defVal = '16.5';
      $('#md-tandem').val(defVal);
   } else {
      if (approved === 'Level 1') defVal = '21.5';
      else if (approved === 'Level 2') defVal = '22.5';
      else if (approved === 'Level 3') defVal = '23.5';
      else defVal = '20.0';
      $('#md-tri').val(defVal);
   }
   $('#mdValue').val(defVal);
}
//
// Handle vehicle changes in interface elements
//

function changeVehicle(selectedVehicle) {
   const path = v.getImagePath();
   $('#vehicleImage').attr('src', path + selectedVehicle.image);

   // Fill the GCM based on the selectedVehicle (except when custom), highlight change
   if (selectedVehicle.gcm > 0) {
      $('#gcmValue').val(selectedVehicle.gcm);
      $('#gcmValue').addClass('highlight-change');
   }

   // Update default drive ratio
   updateDriveRatio(selectedVehicle);

   $('#info-vehicle').addClass('highlight-text');
   $('#info-network').addClass('highlight-text');
   $('#info-gcm').addClass('highlight-text');
   // Remove the highlight after a delay
   setTimeout(function () {
      $('#gcmValue').removeClass('highlight-change');
      $('#info-vehicle').removeClass('highlight-text');
      $('#info-network').removeClass('highlight-text');
      $('#info-gcm').removeClass('highlight-text');
   }, 2000);
}

function updateDriveRatio(selectedVehicle) {
   // determine number of drive axles for the vehicle
   const axles = selectedVehicle.axles;
   const driveAxles = axles[1].max; // The second axle group is always the drive axle.
   // set drive ratio options

   switch (driveAxles) {
      case 2:
         // tandem - 50:50 is default, disable tri options, enable tandems
         $('#driveRatio option').prop('disabled', true);
         $('#driveRatio')[0].selectedIndex = 3; // index based - needs to be updated if select changes.
         $('#driveRatio option:eq(3)').prop('disabled', false); // enable 3
         break;
      case 3:
         // tri - 50:50:0 is default, disable tandem options
         $('#driveRatio option').prop('disabled', true);
         $('#driveRatio')[0].selectedIndex = 0;
         $('#driveRatio option:eq(0), #driveRatio option:eq(1), #driveRatio option:eq(2)').prop('disabled', false); // enable 0,1,2
         break;
      default:
         log.error('Unknown drive axle configuration');
   }
}

//
// Calculations
//

function calculate(selectedVehicle) {
   if (!selectedVehicle) {
      console.error('Undefined vehicle');
      return;
   }
   let mode = getMode();
   if (mode === 'useLoad') calcMaxGrade(selectedVehicle);
   else calcMinMd(selectedVehicle);
}

function calcMaxGrade(selectedVehicle) {
   // called when fields change.
   let gcmValue = parseFloat($('#gcmValue').val());
   let mdValue = parseFloat($('#mdValue').val());
   let frictionValue = parseFloat($('#frictionValue').val());
   let driveRatioValue = parseFloat($('#driveRatio').val());

   if (isNaN(gcmValue) || isNaN(mdValue) || isNaN(frictionValue) || isNaN(driveRatioValue)) {
      // Alert the user or handle the error
      console.error(`Invalid inputs: ${gcmValue}, ${mdValue}, ${frictionValue}, ${driveRatioValue} `);
   } else {
      // If all values are valid numbers, create formData and continue
      let formData = {
         gcmValue: gcmValue,
         mdValue: mdValue,
         frictionValue: frictionValue,
         driveRatioValue: driveRatioValue,
      };
      $.ajax({
         url: '/api/grade-calc',
         type: 'POST',
         data: formData,
         success: function (d) {
            let resultTxt = 'Unknown';
            if (!d.error) {
               let gradient = formatGradient(d.result);
               resultTxt = gradient + '%';
            }
            $('#max-gradient').text(resultTxt);
            $('#gradientResult').addClass('highlight-change');
            $('#info-vehicle').text(selectedVehicle.description);
            $(`#info-network`).text(selectedVehicle.approved + ' - ' + selectedVehicle.network);
            $('#info-gcm').text(formData.gcmValue);
            $('#info-load').text(formData.mdValue);
            $('#info-friction').text(formData.frictionValue);

            // Remove the highlight after a delay
            setTimeout(function () {
               $('#gradientResult').removeClass('highlight-change');
            }, 2000);
         },
         error: function (jqXHR, textStatus, errorThrown) {
            // Handle error here
         },
      });
   }
}

function calcMinMd(selectedVehicle) {
   // called when fields change.
   let gcmValue = parseFloat($('#gcmValue').val());
   let frictionValue = parseFloat($('#frictionValue').val());
   let driveRatioValue = parseFloat($('#driveRatio').val());
   let targetGradient = parseFloat($('#targetGradient').val());
   if (isNaN(gcmValue) || isNaN(targetGradient) || isNaN(frictionValue) || isNaN(driveRatioValue)) {
      // Alert the user or handle the error
      console.error(`Invalid inputs: ${gcmValue}, ${targetGradient}, ${frictionValue}, ${driveRatioValue} `);
   } else {
      let updatedGradient = setGradient(targetGradient); // ensure target is within range.
      // If all values are valid numbers, create formData and continue
      let formData = {
         gcmValue: gcmValue,
         targetGradient: updatedGradient,
         frictionValue: frictionValue,
         driveRatioValue: driveRatioValue,
      };

      $.ajax({
         url: '/api/md-calc',
         type: 'POST',
         data: formData,
         success: function (d) {
            let resultTxt = 'Unknown';

            if (!d.error) resultTxt = d.result + ' t';
            $('#max-load').text(resultTxt);

            $('#loadResult').addClass('highlight-change');
            $('#info-vehicle').text(selectedVehicle.description);
            $('#info-gcm').text(formData.gcmValue);
            $('#info-load').text(formData.mdValue);
            $('#info-friction').text(formData.frictionValue);

            //Remove the highlight after a delay
            setTimeout(function () {
               $('#loadResult').removeClass('highlight-change');
            }, 2000);
         },
         error: function (jqXHR, textStatus, errorThrown) {
            // Handle error here
         },
      });
   }
}

function showHideInputs(hide) {
   if (hide) $('.grad-input-col').fadeOut();
   else $('.grad-input-col').fadeIn();
}

//
// radio button mode support functions
//
function setMode(mode) {
   if (mode === 'useGrade' || mode === 'useLoad') {
      // update radio button
      if (mode === 'useLoad') $('#btnradio1').prop('checked', true);
      else $('#btnradio2').prop('checked', true);
   } else console.error('Invalid mode');
}

function getMode() {
   let id = $('input[name="btnradio"]:checked').attr('id');
   if (id === 'btnradio1') return 'useLoad';
   else if (id === 'btnradio2') return 'useGrade';
   else console.error('Unsupported');
   return 'useLoad';
}

function showMode(mode) {
   // hide show depending on the mode
   if (mode === 'useLoad') {
      $('.axleLoadRow').show();
      $('.targetGradientRow').hide();
      $('#loadResult').hide();
      $('#gradientResult').show();
   } else {
      $('.axleLoadRow').hide();
      $('.targetGradientRow').show();
      $('#loadResult').show();
      $('#gradientResult').hide();
   }
}

function setGradient(value) {
   // ensure within range and update target gradient text field, return new gradient
   let gradient;
   if (value < 0.1) gradient = DEF_GRADIENT;
   else if (value >= 0.1 && value <= MAX_GRADIENT) gradient = value;
   else gradient = MAX_GRADIENT;

   $('#targetGradient').val(gradient);
   return gradient;
}

function formatGradient(value) {
   // ensure within range and add > symbol if over
   if (value > 0 && value <= MAX_GRADIENT) {
      return value;
   } else {
      return `> ${MAX_GRADIENT}`;
   }
}
